"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function OurTechnicalVision() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="261264" id="our-technical-vision" className="py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-md overflow-hidden shadow-2xl shadow-black/50 group">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/futuristic_server_room_ceduna.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/futuristic_server_room_ceduna.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/futuristic_server_room_ceduna.png-wvc-sizes" alt="Apex IT Solutions Technical Infrastructure" className="object-cover w-full h-full transition-transform duration-1000 group-hover:scale-110" loading="lazy" />
              </AspectRatio>
              {}
              <div className="absolute inset-0 border border-primary/20 rounded-md m-4 pointer-events-none transition-opacity duration-500 group-hover:opacity-100 opacity-40 backdrop-blur-[2px]"></div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="mb-6">
              <span className="text-primary font-mono tracking-widest uppercase text-sm mb-4 block">
                Our Technical Vision
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground mb-6 tracking-tight">
                The Apex Story
              </h2>
              <Separator className="w-20 h-1 bg-primary rounded-md" />
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed font-default">
              <p className="text-foreground font-medium text-xl md:text-2xl leading-snug">
                <span className="text-6xl float-left mr-3 mt-1 font-default font-bold text-primary leading-none">F</span>
                rom our roots in Ceduna to the global digital frontier, Apex IT Solutions was founded on the principle that high-performance technology should be accessible to every ambitious enterprise.
              </p>
              
              <p>
                What began as a local initiative in South Australia has evolved into a powerhouse of custom software development and cybersecurity. We don't just build applications; we architect the digital nervous systems that allow modern businesses to thrive in an increasingly automated world.
              </p>
              
              <p>
                Our vision is to bridge the gap between complex AI automation and practical business utility. By combining premium engineering with a technology-focused mindset, we ensure that our clients in Ceduna and beyond are always at the absolute edge of innovation.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-border/30 flex items-center gap-6">
              <div>
                <div className="font-default text-3xl font-bold text-foreground mb-1 tracking-tighter">
                  Apex IT Solutions
                </div>
                <div className="text-xs text-primary uppercase tracking-widest font-mono font-semibold">
                  Est. Ceduna, SA 5690
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}